// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__184ma","containerItemsCenter":"Skeleton_containerItemsCenter__1L4C4"};